export const environment = {
	production: true,
	baseAPIUrl: '/portaleviabilita/api',
	contextRoot: '/portaleviabilita',
	host: 'https://serviziambiente.regione.emilia-romagna.it',
};
